module.exports = __webpack_public_path__ + "images/emoji/mushroom.de5ef5c32213f8ccdcc9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mushroom.png
// module id = xeG9
// module chunks = 13